import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getProducts = () => api.get("/products").then((r) => r.data);
export const createCheckout = (payload) =>
  api.post("/payments/checkout", payload).then((r) => r.data);
export const getPaymentStatus = (sessionId) =>
  api.get(`/payments/status/${sessionId}`).then((r) => r.data);
export const getPaymentMethods = () =>
  api.get("/config/payment-methods").then((r) => r.data);
export const getAdminOverview = (token) =>
  api.get("/admin/overview", { params: { token } }).then((r) => r.data);
export const getAdminEntrants = (token, search) =>
  api.get("/admin/entrants", { params: { token, search } }).then((r) => r.data);
export const getAdminOrders = (token) =>
  api.get("/admin/orders", { params: { token } }).then((r) => r.data);
export const adminEntrantsCsvUrl = (token) =>
  `${API}/admin/entrants.csv?token=${encodeURIComponent(token)}`;
